import { variables } from "../../variables";

export default {
    actions: {
        async _createUserType(context, body){
            return await context.rootGetters.api.post(`${variables.serverUrl}/api/v1/applicant-types/`, body);
        },
        async _updateUserType(context, { body, id }){
            return await context.rootGetters.api.put(`${variables.serverUrl}/api/v1/applicant-types/${id}`, body);
        },
        async _deleteUserType(context, { id }){
            return await context.rootGetters.api.delete(`${variables.serverUrl}/api/v1/applicant-types/${id}`);
        },
        async _getUserType(context, { pageSize, pageNumber, applicantType }){
            return await context.rootGetters.api.get(`${variables.serverUrl}/api/v1/applicant-types/?pageSize=${pageSize}&pageNumber=${pageNumber}&applicantType=${applicantType}`);
        }
    }
}